import industryData from '../data/industryData.json';

export default function filterArea() {
    let antdDistrict = [];
    let districtData = industryData;
    Object.keys(districtData).forEach((index) => {
        let itemLevel1 = {};
        let itemLevel2 = {};
        itemLevel1.value = districtData[index].text;
        itemLevel1.label = districtData[index].text;
        itemLevel1.children = [];
        let data = districtData[index].children;
        Object.keys(data).forEach((index) => {
            itemLevel2.value = data[index].text;
            itemLevel2.label = data[index].text;
            // itemLevel2.children = [];
            // let data2 = data[index].children;
            // let itemLevel3 = {};
            // itemLevel3.children = [];
            // Object.keys(data2).forEach((index) => {
            //     itemLevel3.value = data2[index].text;
            //     itemLevel3.label = data2[index].text;
            //     itemLevel2.children.push(itemLevel3);
            //     itemLevel3 = {};
            // });
            itemLevel1.children.push(itemLevel2);
            itemLevel2 = {};
        });
        antdDistrict.push(itemLevel1);
    });
    return antdDistrict;
}